"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_toastify_1 = require("react-toastify");
var trans_1 = __importDefault(require("@/plugins/trans"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var react_quill_1 = __importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
var material_1 = require("@mui/material");
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var FavoriteBorder_1 = __importDefault(require("@mui/icons-material/FavoriteBorder"));
var Send_1 = __importDefault(require("@mui/icons-material/Send"));
var icons_1 = require("../../icons");
var Button_1 = __importDefault(require("../../Button"));
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var ApplyDialogStyles_1 = require("./ApplyDialogStyles");
var UserContext_1 = __importDefault(require("../../context/UserContext"));
var ContentContext_1 = __importDefault(require("../../context/ContentContext"));
var ApplyForm = function (_a) {
    var vacancy = _a.vacancy, activeStep = _a.activeStep, setActiveStep = _a.setActiveStep;
    var _b = (0, react_1.useContext)(UserContext_1.default), hasCv = _b.hasCv, userId = _b.userId, isAuthenticated = _b.isAuthenticated;
    var applyDialog = (0, react_1.useContext)(ContentContext_1.default).applyDialog;
    var _c = (0, react_1.useState)(''), motivation = _c[0], setMotivation = _c[1];
    var _d = (0, react_1.useState)(), file = _d[0], setFile = _d[1];
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    (0, react_1.useEffect)(function () {
        if (userId) {
            axios_1.default.get("/data/motivation/applications/".concat(vacancy.id)).then(function (_a) {
                var data = _a.data;
                if (data === null || data === void 0 ? void 0 : data.motivation) {
                    setMotivation(data.motivation);
                }
            });
        }
    }, [userId]);
    var handleFileSelected = function (incomingEvent) {
        setFile(incomingEvent.target.files[0]);
    };
    var handleSubmit = function (incomingEvent, incomingSubmit) {
        incomingEvent.preventDefault();
        var formData = new FormData();
        if (!hasCv && !file && incomingSubmit) {
            react_toastify_1.toast.warn(trans_1.default.get('validation.required', { attribute: 'CV' }), {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: true,
                pauseOnHover: false,
            });
            return;
        }
        formData.append('motivation', motivation);
        if (file && file.name) {
            formData.append('cv', file);
        }
        if (incomingSubmit) {
            formData.append('submit', '1');
        }
        // no user, go to register
        if (!userId) {
            setActiveStep(1);
        }
        axios_1.default
            .post("/vacancies/".concat(vacancy.id, "/pre-apply"), formData)
            .then(function (_a) {
            var data = _a.data;
            if (userId) {
                react_toastify_1.toast.success(trans_1.default.get('alerts.general.success'), {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    pauseOnHover: false,
                });
                window.location.href = data;
            }
        })
            .catch(function (error) { return console.log(error); });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.DialogContent, __assign({ sx: __assign(__assign({ display: activeStep === 0 ? 'block' : 'none' }, ApplyDialogStyles_1.applyFormStyles.paddingSpace), { maxWidth: { xs: '100%', md: '80%' } }) }, { children: [(0, jsx_runtime_1.jsx)("form", { children: (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [!hasCv && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "black" }, { children: trans_1.default.get('labels.frontend.applications.add_cv') })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.applyFormStyles.uploadButton }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: file ? ApplyDialogStyles_1.applyFormStyles.applyVacancyHasFile : ApplyDialogStyles_1.applyFormStyles.applyVacancy }, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: trans_1.default.get('strings.frontend.application.accepted_extensions') }) }, { children: (0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: "resume" }, { children: [(0, jsx_runtime_1.jsx)("input", { id: "resume", style: { display: 'none' }, accept: ".doc,.docx,.pdf,.odt,.rtf", onChange: handleFileSelected, type: "file" }), !file && (0, jsx_runtime_1.jsx)(Add_1.default, { sx: { mr: 3 } }), file && file.name ? file.name : "".concat(trans_1.default.get('buttons.general.crud.upload'), " ").concat(trans_1.default.get('columns.profile.resume'))] })) })) })) }))] })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "black" }, { children: trans_1.default.get('labels.frontend.applications.add_motivation') })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.applyFormStyles.quill }, { children: (0, jsx_runtime_1.jsx)(react_quill_1.default, { theme: "snow", value: motivation, onChange: setMotivation }) }))] }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", sx: ApplyDialogStyles_1.applyFormStyles.tipBox }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.applyFormStyles.tipBoxIcon }, { children: [(0, jsx_runtime_1.jsx)(icons_1.RFIcon, { sx: { height: '3em', width: '3em' } }), trans_1.default.get('strings.frontend.application.motivation_tips_title')] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.applyFormStyles.tipBoxText }, { children: (0, html_react_parser_1.default)(applyDialog.motivationTips) }))] }))] })), (0, jsx_runtime_1.jsx)(material_1.DialogActions, __assign({ sx: __assign({ display: activeStep === 0 ? 'block' : 'none' }, ApplyDialogStyles_1.applyFormStyles.paddingSpace) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: isSmallScreen ? ApplyDialogStyles_1.applyFormStyles.buttonsMobile : ApplyDialogStyles_1.applyFormStyles.buttons }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "submit", onClick: function (event) { return handleSubmit(event, false); }, id: "save", endIcon: (0, jsx_runtime_1.jsx)(FavoriteBorder_1.default, {}), outlined: true, style: { order: isSmallScreen ? 1 : 0 } }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginRight: '.75rem' } }, { children: trans_1.default.get('buttons.frontend.application.save_concept') })) })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "submit", onClick: function (event) { return handleSubmit(event, true); }, id: "send", endIcon: (0, jsx_runtime_1.jsx)(Send_1.default, {}) }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginRight: '.75rem' } }, { children: trans_1.default.get("buttons.frontend.application.".concat(isAuthenticated ? 'send' : 'step2')) })) }))] })) }))] }));
};
exports.default = ApplyForm;
